function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#949494;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "\u041C\u043E\u043D\u0442\u0430\u0436\u043D\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C 1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "\\u043C\\u043E\\u0441\\u043A\\u0432\\u0430"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7"
}, /*#__PURE__*/React.createElement("path", {
  id: "moscow",
  className: "cls-1",
  d: "M7.86,13.06H6.57v1.29H5.29V13.06H4v7.07H9.14V14.35H7.86ZM11.72,6,13,5,14.3,6l-.65-1.61,1.29-.64-1.56-.09L13,2l-.37,1.65-1.55.09,1.29.64Zm9,7.08v1.29H19.43V13.06H18.14v1.29H16.86v5.79H22V13.06ZM13,6l-1.93,5.14H9.79v9h1.93V17.56a1.29,1.29,0,1,1,2.57,0v2.57h1.93v-9H14.93Zm0,7.71a1.29,1.29,0,1,1,1.29-1.29A1.29,1.29,0,0,1,13,13.71Z"
})));

var SvgMoskva = function SvgMoskva(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    viewBox: "0 0 26 24",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoskva, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moskva.f8d3bdae.svg";
export { ForwardRef as ReactComponent };